import { axios } from '~/plugins/axios'

const actions = {
  async fetchGroups() {
    const resp = await axios.get('/api/groups')
    const raw = (resp.data && resp.data.data) || resp.data || []

    return (Array.isArray(raw) ? raw : [])
      .map((item) => {
        let memberIds = item.members_ids
        if (memberIds && typeof memberIds === 'object' && !Array.isArray(memberIds)) {
          memberIds = Object.values(memberIds)
        }
        return {
          id: Number(item.id),
          name: item.name || String(item.id),
          members_ids: (Array.isArray(memberIds) ? memberIds : [])
            .map((id) => Number(id))
            .filter((id) => Number.isFinite(id) && id > 0),
        }
      })
      .filter((item) => Number.isFinite(item.id) && item.id > 0)
  },

  async fetchSupervisors() {
    const resp = await axios.get('/api/reports/kpi/rg/supervisors')
    const raw = (resp.data && resp.data.data) || resp.data || []

    return (Array.isArray(raw) ? raw : []).map((item) => ({
      id: Number(item.id),
      name: item.name
        || [item.last_name, item.first_name].filter(Boolean).join(' ').trim()
        || String(item.id),
      first_name: item.first_name || '',
      last_name: item.last_name || '',
    }))
  },

  async fetchReport(_, payload) {
    const resp = await axios.post('/api/reports/kpi/rg', payload)
    return (resp.data && resp.data.data) || resp.data
  },

  async exportReport(_, payload) {
    return axios.post('/api/reports/kpi/rg/export', payload, {
      responseType: 'blob',
    })
  },

  async saveOverride(_, payload) {
    const resp = await axios.post('/api/reports/kpi/rg/override', payload)
    return (resp.data && resp.data.data) || resp.data
  },

  async deleteOverride(_, payload) {
    const resp = await axios.delete('/api/reports/kpi/rg/override', { data: payload })
    return (resp.data && resp.data.data) || resp.data
  },
}

export default {
  namespaced: true,
  actions,
}
